'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = HotelTypeDescriptionPanel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _defaultClasses = require('../../../../../constants/defaultClasses');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HotelTypeDescriptionPanel(props) {
  var text = props.text,
      components = props.components;


  return _react2.default.createElement(
    'table',
    { style: _defaultClasses.mainTableClass, 'data-component': 'HotelHeader' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, (0, _defaultClasses.containerClass)(components.HotelRoomContainer), { padding: '10px' }) },
          _react2.default.createElement(
            'span',
            { style: (0, _defaultClasses.containerClass)(components.HotelRoomLabel) },
            text
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Hotel/Email/Passive/HotelTypeDescriptionPanel.jsx
// module id = 1532
// module chunks = 0